import React, { useState, useContext } from 'react';
import DataTable, { createTheme } from 'react-data-table-component';
import { ThemeContext } from 'styled-components';
import { useSelector } from 'react-redux';
import Switch from 'react-switch';
import Dropdown from '../dropdown/dropdown';
import {
  TableEmpty,
  CadastroUsuarioModal,
  Icon,
  ModalClose,
  ModalConfirmation,
  Loader,
  Skeleton,
} from '..';
import { notifyError, notifySuccess } from '../../utils';
import { icons } from '../../assets';
import { ReactComponent as TrashTransparentIcon } from '../../assets/icons/TrashTransparent.svg';

import {
  deleteExistentUser,
  postEditStatusUser,
  postEditUser,
} from '../../services';
import * as s from './styled-users-table';

const TableUsuarios = ({ loading, data, currentCustomers, buscaUsuarios }) => {
  const [closeConfirmation, setCloseConfirmation] = useState(false);
  const { user } = useSelector((state) => state.usuario);
  const [isDeletingUser, setIsDeletingUser] = useState('');
  const { title, colors } = useContext(ThemeContext);
  const [isModalEditVisible, setIsModalEditVisible] = useState(false);
  const [isModalEditVisibleConcluido, setIsModalEditVisibleConcluido] =
    useState(false);
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [usuarioEditado, setUsuarioEditado] = useState();
  const [usuarioSelecionado, setUsuarioSelecionado] = useState({
    name: '',
    email: '',
    empresa: '',
    papel: '',
  });
  const listPapel = user.company
    ? [
        { label: 'Admin Local', value: 'admin' },
        { label: 'Operador', value: 'operador' },
        { label: 'Visualizador', value: 'visualizador' },
      ]
    : [
        { label: 'Operador', value: 'operador' },
        { label: 'Visualizador', value: 'visualizador' },
      ];

  const roleAjuste = (role) => {
    switch (role) {
      case 'admin':
        return { label: 'Admin Local', value: 'admin' };
      case 'operador':
        return { label: 'Operador', value: 'operador' };
      case 'visualizador':
        return { label: 'Visualizador', value: 'visualizador' };
      default:
        return { label: 'Definir', value: '' };
    }
  };

  createTheme('darkmode', {
    background: {
      default: colors.card,
    },
    divider: {
      default: colors.disabled,
    },
    highlightOnHover: {
      default: colors.lightgrey,
    },
  });

  const deleteCell = {
    name: 'Excluir',
    selector: '',
    sortable: false,
    maxWidth: '5%',
    minWidth: '85px',
    cell: (row) => (
      <>
        {isDeletingUser === row.id ? (
          <Loader color="#1e2944" width={25} height={25} />
        ) : (
          <s.TrashButtonIcon
            disabled={isDeletingUser}
            onClick={() => deleteUser(row)}
            size={25}
          >
            <TrashTransparentIcon />
          </s.TrashButtonIcon>
        )}
      </>
    ),
    style: {
      display: 'flex',
      justifyContent: 'center',
    },
  };

  const columns = [
    {
      name: 'Usuário',
      selector: '',
      sortable: false,
      minWidth: '105px',
      cell: ({ name }) => <s.Label color={colors.darkerblue}>{name}</s.Label>,
    },
    {
      name: 'Empresa',
      selector: '',
      sortable: false,
      minWidth: '120px',
      maxWidth: '8%',
      cell: ({ customer, company }) => (
        <s.Label>
          {customer ? customer.name : ''}
          {company ? company.name : ''}
        </s.Label>
      ),
    },
    {
      name: 'Email de Contato',
      selector: '',
      sortable: false,
      minWidth: '175px',
      cell: ({ email }) => <s.Label color={colors.disabled}>{email}</s.Label>,
    },
    {
      name: 'Acesso',
      selector: '',
      sortable: false,
      cell: (row) => (
        <Dropdown
          style={{
            menuList: (provided) => ({
              ...provided,
              maxHeight: '20vh',
            }),
            control: (provided) => ({
              ...provided,
              marginTop: '0.6vh',
              minWidth: '125px',
              width: '12.3vw',
              borderRadius: 16,
              backgroundColor: colors.card,
              borderColor: colors.disabled,
              boxShadow: 'none',
            }),
            singleValue: (provided) => ({
              ...provided,
              color: colors.label,
            }),
            option: (provided, state) => ({
              ...provided,
              backgroundColor: state.isSelected
                ? colors.blue
                : state.isFocused
                ? colors.lightgrey
                : colors.card,
              color: colors.label,
            }),
            menu: (provided) => ({
              ...provided,
              backgroundColor: colors.card,
              zIndex: 1001,
            }),
          }}
          onChange={(opt) => {
            editarUsuarioRole({
              id: row.id ? row.id : '',
              name: row.name ? row.name : '',
              email: row.email ? row.email : '',
              empresa: !row.customer ? '' : row.customer.id,
              papel: opt.value,
            });
          }}
          value={roleAjuste(row.role)}
          placeholder="Definir"
          disabled={
            !!(
              (row.role === 'admin' && !user.company) ||
              row.role === 'higra' ||
              user.id === row.id
            )
          }
          isSearchable={false}
          options={listPapel}
        />
      ),
    },
    {
      name: 'Status',
      selector: '',
      sortable: false,
      maxWidth: '8%',
      cell: ({ status }) => (
        <s.Label color={status ? colors.green : colors.darkerblue}>
          {status ? 'Ativo' : 'Inativo'}
        </s.Label>
      ),
    },
    {
      name: 'Ativação',
      selector: '',
      sortable: false,
      maxWidth: '7%',
      minWidth: '100px',
      cell: ({ status, id }) => (
        <Switch
          onColor={colors.green}
          offColor={colors.darkerblue}
          onHandleColor={colors.white}
          offHandleColor={colors.white}
          checkedIcon={false}
          uncheckedIcon={false}
          checked={status}
          disabled={!(status !== null && user.id !== id)}
          onChange={async () => {
            if (user.id !== id) {
              await postEditStatusUser(id, !status);
              await buscaUsuarios();
            } else {
              notifyError('Não é possível editar seu próprio usuário.');
            }
          }}
        />
      ),
    },
    {
      name: 'Editar',
      selector: '',
      sortable: false,
      maxWidth: '5%',
      minWidth: '85px',
      cell: (row) => (
        <s.IconButton
          type="button"
          title="Editar usuário"
          onClick={() => {
            if (user.id !== row.id) {
              setIsModalEditVisible(true);
              setUsuarioSelecionado({
                id: row.id ? row.id : '',
                name: row.name ? row.name : '',
                email: row.email ? row.email : '',
                empresa: row.customer ? row.customer.id : '',
                company: !!row.company,
                papel: row.role ? row.role : '',
                status: row.status,
              });
            } else {
              notifyError('Não é possível editar seu próprio usuário.');
            }
          }}
        >
          <Icon name="pencil" size={18} />
        </s.IconButton>
      ),
      style: {
        display: 'flex',
        justifyContent: 'center',
      },
    },
  ];

  if (user.role === 'higra' && user.company.name === 'Higra') {
    columns.push(deleteCell);
  }

  const deleteUserFailed = (error) => {
    if (error && error.message) notifyError(error.message);
    else notifyError('Ocorreu um erro ao deletar o usuário');
  };

  const deleteUserSuccessfully = () => {
    notifySuccess('Usuário foi deletado com sucesso');
    buscaUsuarios();
  };

  const deleteUser = (userData) => {
    setIsDeletingUser(userData.id);

    deleteExistentUser(userData.id)
      .then(deleteUserSuccessfully)
      .catch(deleteUserFailed)
      .finally(() => setIsDeletingUser(''));
  };

  const editarUsuarioRole = (values) => {
    postEditUser(values.id, {
      name: values.name,
      email: values.email,
      role: values.papel,
    })
      .then(() => {
        notifySuccess('Usuário foi editado com sucesso');
        buscaUsuarios();
      })
      .catch((error) => {
        if (error && error.message) notifyError(error.message);
        else notifyError('Ocorreu um erro ao salvar o usuário');
      });
  };

  const editarUsuario = (values) => {
    postEditUser(
      values.id,
      values.company
        ? {
            company: user.company ? user.company.id : '',
            name: values.name,
            email: values.email,
            role: values.papel,
          }
        : {
            customer: values.empresa,
            name: values.name,
            email: values.email,
            role: values.papel,
          }
    )
      .then(() => {
        setIsModalEditVisible(false);
        setConfirmationModal(false);
        setIsModalEditVisibleConcluido(true);
        buscaUsuarios();
      })
      .catch((error) => {
        if (error && error.message) notifyError(error.message);
        else notifyError('Ocorreu um erro ao salvar o usuário');

        setConfirmationModal(false);
      });
  };

  return (
    <>
      {confirmationModal ? (
        <ModalConfirmation
          onClose={() => {
            editarUsuario(usuarioEditado);
          }}
          onCloseConfirmation={setConfirmationModal}
        />
      ) : null}
      {isModalEditVisibleConcluido ? (
        <CadastroUsuarioModal
          onClose={() => {
            setIsModalEditVisibleConcluido(false);
          }}
          onCloseConfirmation={setCloseConfirmation}
          setTelaConcluido={setIsModalEditVisible}
          formikInitialValues={usuarioSelecionado}
          currentCustomers={currentCustomers}
          telaConcluido={isModalEditVisibleConcluido}
          title="Editar Usuario"
          sucesso="Usuário editado com sucesso!"
          iconFinal={icons.AcessosIconEdit}
        />
      ) : null}
      {isModalEditVisible ? (
        <CadastroUsuarioModal
          onClose={() => {
            setIsModalEditVisible(false);
            buscaUsuarios();
          }}
          submit={setUsuarioEditado}
          onCloseConfirmation={setCloseConfirmation}
          setConfirmationModal={setConfirmationModal}
          setTelaConcluido={setIsModalEditVisible}
          telaConcluido={isModalEditVisibleConcluido}
          formikInitialValues={usuarioSelecionado}
          currentCustomers={currentCustomers}
          title="Editar Usuário"
          dadosAbaixo="Modifique os dados abaixo:"
          msgButton="Confirme suas modificações"
          labelButton="SALVAR"
          sucesso="Usuário editado com sucesso!"
          iconFinal={icons.AcessosIconEdit}
        />
      ) : null}
      {closeConfirmation ? (
        <ModalClose
          onClose={() => {
            setIsModalEditVisible(false);
            buscaUsuarios();
            setCloseConfirmation(false);
          }}
          onCloseConfirmation={setCloseConfirmation}
        />
      ) : null}
      <DataTable
        theme={title === 'light' ? 'default' : 'darkmode'}
        noHeader
        columns={columns}
        data={data}
        highlightOnHover
        fixedHeader
        responsive
        pagination={false}
        persistTableHead
        progressPending={loading}
        noDataComponent={
          <TableEmpty
            titulo="Nenhum usuário foi encontrado"
            subtitulo="Cadastre usuários para começar"
            icon={icons.AcessosIconGray}
          />
        }
        ignoreRowClick
        customStyles={{
          table: {
            style: {
              flex: 1,
              marginTop: '10px',
              marginBottom: '5px',
              height: '100%',
              paddingBottom: '1.0vh',
            },
          },
          headRow: {
            style: {
              borderBottomColor: colors.disabled,
            },
          },
          rows: {
            style: {
              borderBottomColor: colors.disabled,
            },
          },
          cells: {
            style: {
              textAlign: 'center',
              paddingLeft: 0,
              paddingRight: 0,
            },
          },
          headCells: {
            style: {
              textAlign: 'center',
              paddingLeft: 0,
              paddingRight: 0,
            },
          },
        }}
        progressComponent={
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              flex: 1,
              padding: 16,
              gap: 8,
            }}
          >
            <Skeleton count={6} height="32px" />
          </div>
        }
      />
    </>
  );
};

export default TableUsuarios;
